import { http } from "./client";

export const fetchManageGroupAppDefinitions = () =>
    http.get("ApplicationStatusesRoles/definitions");

export const fetchManageGroupAppRole = (RoleID) =>
    http.get("ApplicationStatusesRoles", { params: { RoleID } });

export const updateManageGroupAppRole = (payload) =>
    http.patch("ApplicationStatusesRoles/update", payload);
